import React from 'react'
import { InfoBox } from '@mobi/component-library/Feedback/InfoBox'
import type { BetSlipItem } from '@mobi/betslip/types'
import { useAppSelector } from '@mobi/betslip/Store/hooks'
import { selectAccountBalance, selectWorkflowStatus } from '@mobi/betslip/Store/Workflow/selectors'
import { selectMultiBetError } from '@mobi/betslip/Store/Bets/selectors'

export const InsufficientFundsError: React.FC<{
  singleItems: BetSlipItem[]
  /** Cost after bonus has been subtracted */
  finalCost: number
}> = ({ finalCost, singleItems }) => {
  const workflowStatus = useAppSelector(selectWorkflowStatus)
  const accountBalance = useAppSelector(selectAccountBalance)
  const multiBetError = useAppSelector(selectMultiBetError)

  const isClientSideInsufficientFundsError =
    workflowStatus === 'ready' && accountBalance !== null && accountBalance < finalCost

  const hasInsufficientFundsServerError =
    (!!multiBetError && multiBetError.betErrorType === 'InsufficientFunds') ||
    singleItems.some(x => x.betErrorType === 'InsufficientFunds')

  if (hasInsufficientFundsServerError || isClientSideInsufficientFundsError)
    return (
      <InfoBox size='md' color='red'>
        <span>Low balance</span>
        <div>Please make a deposit or adjust stake to place a bet.</div>
      </InfoBox>
    )

  return null
}
